import { useState, useEffect } from "react";
import { FiPhoneCall, FiMenu, FiX } from "react-icons/fi";
import logo from "../assets/logo.png";

const navLinks = [
  { label: "About", href: "#about" },
  { label: "Menu", href: "#menu" },
  { label: "Chef", href: "#chef" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#footer" },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-black/70 backdrop-blur-xl shadow-soft" : "bg-transparent"
      }`}
    >
      <nav className="container flex flex-wrap items-center justify-between gap-4 py-4">
        <a
          href="#home"
          className="flex items-center gap-3 text-xl md:text-2xl font-display tracking-[0.2em] text-brand-gold"
        >
          <img
            src={logo}
            alt="Pannai Veetu Biryani logo"
            className="h-24 w-auto object-contain sm:h-16 md:h-20"
            width="160"
            height="48"
            loading="lazy"
          />
          <span className="hidden md:inline-block">Pannai Veetu Biryani</span>
        </a>
        <div className="hidden lg:flex items-center gap-8 text-sm uppercase tracking-[0.3em] text-brand-cream/80">
          {navLinks.map((link) => (
            <a key={link.label} href={link.href} className="hover:text-brand-gold transition">
              {link.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <a
            href="tel:+1234567890"
            className="hidden md:flex items-center gap-2 px-4 py-2 rounded-full border border-brand-gold/40 text-brand-gold hover:bg-brand-gold/10 transition"
          >
            <FiPhoneCall />
            Reserve
          </a>
          <button
            className="lg:hidden text-2xl text-brand-cream"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            {open ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </nav>
      {open && (
        <div className="lg:hidden bg-black/90 backdrop-blur-xl py-6 border-t border-white/5">
          <div className="container flex flex-col gap-6 text-center text-brand-cream">
            {navLinks.map((link) => (
              <a key={link.label} href={link.href} onClick={() => setOpen(false)} className="text-lg">
                {link.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
